import { createStore, combineReducers } from 'redux';

// Initial state
const initialAuthState = {
  isAuthenticated: false,
  email: null,
  role: null,
  isSupportRep: false,
  needsSurvey: false,
  surveyData: null, // roles, seniorities, businessSegments, etc.
  userDetails: null,
  loading: false,
  error: null,
  // New fields for registration flow
  registrationData: null, // { name, company } for registration flow
  engagementStatus: null, // guest, requested, approved, rejected
  // Connect engagement roles (lowercased): purchase, lease, invoices, rma,
  // shipments. Drive marketplace tab visibility (ACON-60).
  connectRoles: [],
};

// Auth reducer
const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
        error: null,
      };
    case 'SET_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'SET_AUTH':
      return {
        ...state,
        isAuthenticated: true,
        email: action.payload.email,
        role: action.payload.role,
        isSupportRep: action.payload.isSupportRep || false,
        fullName: action.payload.fullName || null,
        company: action.payload.company || null,
        phone: action.payload.phone || null,
        jobTitle: action.payload.jobTitle || null,
        partSales: action.payload.partSales || false,
        mro: action.payload.mro || false,
        connectRoles: Array.isArray(action.payload.connectRoles)
          ? action.payload.connectRoles.map((r) => String(r).trim().toLowerCase())
          : state.connectRoles,
        loading: false,
        error: null,
      };
    case 'SET_NEEDS_SURVEY':
      return {
        ...state,
        needsSurvey: true,
        surveyData: action.payload,
        loading: false,
      };
    case 'CLEAR_NEEDS_SURVEY':
      return {
        ...state,
        needsSurvey: false,
        surveyData: null,
      };
    case 'SET_USER_DETAILS':
      return {
        ...state,
        userDetails: action.payload,
      };
    case 'SET_EMAIL':
      return {
        ...state,
        email: action.payload,
      };
    case 'SET_REGISTRATION_DATA':
      return {
        ...state,
        registrationData: action.payload,
      };
    case 'SET_ENGAGEMENT_STATUS':
      return {
        ...state,
        engagementStatus: action.payload,
      };
    case 'CLEAR_AUTH':
      return initialAuthState;
    default:
      return state;
  }
};

// Action creators
export const setLoading = (loading) => ({ type: 'SET_LOADING', payload: loading });
export const setError = (error) => ({ type: 'SET_ERROR', payload: error });
export const setAuth = (authData) => ({ type: 'SET_AUTH', payload: authData });
export const setNeedsSurvey = (surveyData) => ({ type: 'SET_NEEDS_SURVEY', payload: surveyData });
export const clearNeedsSurvey = () => ({ type: 'CLEAR_NEEDS_SURVEY' });
export const setUserDetails = (details) => ({ type: 'SET_USER_DETAILS', payload: details });
export const setEmail = (email) => ({ type: 'SET_EMAIL', payload: email });
export const setRegistrationData = (data) => ({ type: 'SET_REGISTRATION_DATA', payload: data });
export const setEngagementStatus = (status) => ({ type: 'SET_ENGAGEMENT_STATUS', payload: status });
export const clearAuth = () => ({ type: 'CLEAR_AUTH' });

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
});

// Create store
const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;

